import { Column } from 'react-table';

const SelectUserTableColumnConfig: Column[] = [
    {
        Header: 'Trigram',
        accessor: 'trigram',
    },
    {
        Header: 'First Name',
        accessor: 'firstName',
    },
    {
        Header: 'Last name',
        accessor: 'lastName',
    },
    {
        Header: 'Email',
        accessor: 'email',
    },
];

export default SelectUserTableColumnConfig;

export const DefaultVisibleUserColumns = ['trigram', 'firstName', 'lastName', 'email'];

export const SearchableUserTableColumnConfig = ['trigram', 'firstName', 'lastName', 'email'];
